<template>
  <div class="CareSystem">
    <div class="page_img">
      <img src="@/assets/img/care_system.jpg" alt="">
    </div>
    <div class="content page_content flex_row">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="page_summary font_shadow">24小时呵护云诊视系统</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/care_main.png" alt="">
      <div class="care_explain main_explain">青少年屈光发育档案的建立以及中老年人的眼健康管理，VISUMALL平台全部记录，并提供专业的关于预防与防控指导，24小时进行监测预警，为眼健康提供放心托管</div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">顾客端全生命周期24小时健康管理</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="system_main flex_row">
        <img src="@/assets/img/care_main1.png" alt="">
      </div>
    </div>
    <div class="container">
      <div class="container_title">
        顾客健康档案管理
      </div>
      <div class="container_content flex_row">
        <div class="container_item flex_row" v-for="item in programList">
          <img :src="item.img" alt="">
          <span>{{item.title}}</span>
        </div>
      </div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">专家在线云诊视24小时诊疗服务</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="system_main flex_row">
        <img src="@/assets/img/care_main2.png" alt="">
      </div>
    </div>
    <div class="container">
      <div class="container_title">
        医生云端诊室
      </div>
      <div class="container_content flex_row">
        <div class="container_item flex_row" v-for="item in expertList">
          <img :src="item.img" alt="">
          <span>{{item.title}}</span>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'CareSystem',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
      programList: [],
      expertList: []
    }
  },
  created() {
    let programList = [
      {
        img: 'https://www.visumall.com/public/img/care_program1.png',
        title: '手机预约挂号'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program2.png',
        title: '预约叫号提醒'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program3.png',
        title: '人工智能随访'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program4.png',
        title: '远程专家会诊'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program5.png',
        title: '消费在线支付'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program6.png',
        title: '在线慢病自测'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program7.png',
        title: '在线健康体检'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program8.png',
        title: '私人家庭医生'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program9.png',
        title: '传播分享分销'
      },
      {
        img: 'https://www.visumall.com/public/img/care_program10.png',
        title: '家庭账户管理'
      },

    ];
    let expertList = [
      {
        img: 'https://www.visumall.com/public/img/care_expert1.png',
        title: '手机在线排班'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert2.png',
        title: '多点执业号池'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert3.png',
        title: '人工智能随访'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert4.png',
        title: '分级诊疗转诊'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert5.png',
        title: '云端药房管理'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert6.png',
        title: '医患实时沟通'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert7.png',
        title: '在线患者管理'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert8.png',
        title: '评分实时预警'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert9.png',
        title: '健康科普宣教'
      },
      {
        img: 'https://www.visumall.com/public/img/care_expert10.png',
        title: '课题样本收集'
      },

    ];
    this.programList = programList;
    this.expertList = expertList;
  },
}
</script>

<style scoped lang="scss">
.CareSystem {
  .content {
    margin: 0.4rem 0 1.5rem;
  }
  .main {
    width: 100%;
    img {
      width: 40%;
    }
    .care_explain {
      margin: 1rem 0 1rem;
      width: 65%;
      padding: 0.25rem 0.45rem;
      font-size: 0.19rem;
      font-weight: 500;
    }
  }
  .system {
    margin-bottom: 1.3rem;
    .system_title {
      .sys_summary {
        font-weight: bold;
        font-size: 0.3rem;
      }
    }
    .system_main {
      margin-top: 0.8rem;
      img {
        width: 55%;
      }
    }
  }
  .container {
    .container_title {
      margin-bottom: 0.35rem;
      font-weight: 500;
      font-size: 0.25rem;
      color: #005AFF;
    }
    .container_content {
      margin-bottom: 1.3rem;
      flex-wrap: wrap;
      .container_item {
        width: 20%;
        flex-direction: column;
        margin-bottom: 0.55rem;
        img {
          width: 80%;
        }
        span {
          margin-top: 0.1rem;
          font-size: 0.22rem;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
